import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BrandJoinListContainer from '../../containers/brand/BrandJoinListContainer';
import { BRAND_PAGE_NAME } from '../../constants/service/app/brandConstants';

const BrandJoinList = () => {
  return (
    <PageTemplate pageName={BRAND_PAGE_NAME.BRAND_JOIN_REQUEST_LIST}>
      <BrandJoinListContainer pageName={BRAND_PAGE_NAME.BRAND_JOIN_REQUEST_LIST} />
    </PageTemplate>
  );
};

export default BrandJoinList;
